import { StepId } from './shared/types';

export const SHOW_QUESTIONNAIRE_COOKIE = 'show_questionnaire';
export const DEFAULT_STEP: StepId = 'intent';
